import classNames from "classnames";

import Tooltip from "features/components/Tooltip";
import LinkButton from "features/ui/LinkButton";

interface OpenDetailButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  tooltip?: string;
}

const OpenDetailsButton = ({
  children,
  onClick,
  className,
  tooltip,
}: OpenDetailButtonProps) => {
  if (tooltip === "") {
    return null;
  }

  const button = (
    <LinkButton
      onClick={onClick || (() => {})}
      className={classNames("w-full block", className)}
    >
      {children}
    </LinkButton>
  );

  if (tooltip) {
    return <Tooltip title={tooltip}>{button}</Tooltip>;
  }

  return button;
};

export default OpenDetailsButton;
